import { render, staticRenderFns } from "./YagiChatBotAiResultBubble.vue?vue&type=template&id=422df187&scoped=true"
import script from "./YagiChatBotAiResultBubble.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiChatBotAiResultBubble.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiChatBotAiResultBubble.vue?vue&type=style&index=0&id=422df187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422df187",
  null
  
)

export default component.exports